import { Button, ButtonProps, Typography } from '@material-ui/core'

import { getUserBrowser } from 'modules'

import { ReactComponent as ChromeIcon } from 'assets/icons/chrome.svg'
import { ReactComponent as EdgeIcon } from 'assets/icons/edge.svg'

const isEdge = getUserBrowser() === 'edge'

type Props = {
    onClick: (browserType: string) => void
} & Omit<ButtonProps, 'onClick'>

export const ExtensionButton = ({ onClick, style = {}, ...rest }: Props) => (
    <Button
        data-cy="extension-button"
        startIcon={isEdge ? <EdgeIcon /> : <ChromeIcon />}
        onClick={() => onClick(isEdge ? 'edge' : 'chromium')}
        style={{
            ...style,
            width: 220,
            textTransform: 'uppercase',
            letterSpacing: '1.25 px'
        }}
        {...rest}
    >
        <Typography style={{ fontSize: 'inherit', fontWeight: 'inherit' }}>
            Add Guidde to {isEdge ? 'Edge' : 'Chrome'}
        </Typography>
    </Button>
)
